import * as THREE from 'three'
import ReactDOM from 'react-dom'
import React, { Suspense, useState, useRef, useMemo, useEffect } from 'react'
import { useLoader } from "@react-three/fiber"
import { useAspect } from "@react-three/drei"

export default function Image({ src, material, scaleFactor = 0.1, meshAttr = {} }) {
  const texture = useLoader(THREE.TextureLoader, src);
  const mesh = useRef(null);
  const [res, setRes] = useState([0,0]);
  const image = useMemo(() => new window.Image(src), [src]);
  const scale = useAspect(res[0], res[1], scaleFactor);

  useEffect(function(){
      image.src = src;
      image.removeAttribute("width");

      const onImgLoaded = () => {
          setRes([image.width, image.height])
      };

      image.addEventListener('load', onImgLoaded);
      return () => {
          image.removeEventListener('load', onImgLoaded)
      };
  }, [src, image])

  return (
    <mesh ref={mesh} scale={scale} {...meshAttr} toneMapped={false}>
      <planeGeometry attach="geometry" args={[1,1]} />
      <meshBasicMaterial ref={material} attach="material" map={texture} transparent toneMapped={false}/>
    </mesh>
  )
}
